export function isCreateFreightRequired(customizationEnabled: boolean): boolean {
  return !customizationEnabled;
}

export function resetNewProductFreightOnModeChange(customizationEnabled: boolean, currentId: string): string {
  return customizationEnabled ? "" : currentId;
}

export function resolveCreateFreightTemplateId(customizationEnabled: boolean, selectedId: string): string | null {
  return customizationEnabled ? null : selectedId || null;
}
